<template>
  <div style="margin-top: 20px; margin-bottom: 20px">
    <el-card class="box-card" style="position: relative">
      <div class="box-card-content">
        <div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <template v-for="(item, index) in list">
              <el-breadcrumb-item v-if="list.length == index + 1"
                >{{ item.name }}
              </el-breadcrumb-item>
              <el-breadcrumb-item v-else :to="{ path: item.path }">{{
                item.name
              }}</el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div v-if="message != ''">
          <el-alert :title="message" type="success"> </el-alert>
        </div>
        <div
          v-if="buttonArray"
          style="position: absolute; top: 7px; right: 10px"
        >
          <span
            v-for="(item, index) in buttonArray"
            :key="index"
            style="margin-left: 10px"
          >
            <el-popconfirm
              v-if="item.msg"
              :title="item.msg"
              @confirm="$emit(item.method)"
            >
              <el-button
                slot="reference"
                :disabled="item.disabled"
                :type="item.type"
                >{{ item.title }}</el-button
              >
            </el-popconfirm>

            <el-button
              v-else
              style="right: 0px"
              :type="item.type"
              :disabled="item.disabled"
              v-on:click="$emit(item.method)"
              >{{ item.title }}
            </el-button>
          </span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: "",
    secondList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isShowBack: false, //判断返回按钮的显示，默认不显示
    isSecond: {
      default: true,
    },
    message: {
      default: "",
    },
    buttonArray: {
      type: Array,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$store.commit("setRoute", this.title);
    if (this.isSecond) {
      this.list = this.$store.state.routeList;
      //      this.list.push(this.title);
    } else {
      this.list = this.secondList;
    }
  },
};
</script>
<style scoped>
.box-card-content {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
}
</style>
